import React, { useEffect, useState } from 'react';
import axios from 'axios';
const App = () => {
  const [papers, setPapers] = useState([]);
  const [selectedPaper, setSelectedPaper] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);
  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const response = await axios.get('https://api.videvelopers.com/v6/e-paper/get-papers');
        if (!response.data.error) {
          setPapers(response.data.papers);
        }
      } catch (error) {
        console.error('Error fetching papers', error);
      }
    };
    fetchPapers();
  }, []);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedPaper) {
      alert("Please select a paper.");
      return;
    }
    let fileContent = text; // if text has been provided in the textbox
    // If a file has been selected, read the content from it
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        fileContent = e.target.result;
        sendData(fileContent);
      };
      reader.readAsText(file);
    } else {
      sendData(fileContent);
    }
  };
  const sendData = async (fileContent) => {
    const formattedDate = new Date(selectedDate).toISOString().split('T')[0];
    try {
      const response = await axios.post('https://api.videvelopers.com/v6/e-paper/add-entry', {
        paperName: selectedPaper,
        date: formattedDate,
        title: title || `${selectedPaper}, ${new Date(selectedDate).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}`,
        text: fileContent
      });
      if (!response.data.error) {
        alert(response.data.message);
        // Resetting fields except for paperName and date
        setTitle('');
        setText('');
        setFile(null);
      } else {
        alert('Error: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error submitting form', error);
    }
  };
  return (
    <div style={{ padding: "20px" }}>
      <h1>Papers Form</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Choose Paper:</label>
          <select value={selectedPaper} onChange={(e) => setSelectedPaper(e.target.value)}>
            <option value="">Select a paper</option>
            {papers.map((paper, index) => (
              <option key={index} value={paper.paperName}>{paper.paperName}</option>
            ))}
          </select>
        </div>
        <div>
          <label>Choose Date:</label>
          <input 
            type="date" 
            value={selectedDate} 
            onChange={(e) => setSelectedDate(e.target.value)} 
          />
        </div>
        <div>
          <label>Title:</label>
          <input 
            type="text" 
            value={title || `${selectedPaper}, ${new Date(selectedDate).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}`} 
            onChange={(e) => setTitle(e.target.value)} 
          />
        </div>
        <div>
          <label>Choose File (.txt):</label>
          <input type="file" accept=".txt" onChange={handleFileChange} />
        </div>
        <div>
          <label>Text Input:</label>
          <textarea 
            rows="5" 
            value={text} 
            onChange={(e) => setText(e.target.value)} 
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};
export default App;